import navigationConstants from '@navigation/navigationConstants';
import { useNavigation } from '@react-navigation/native';
import { FAB } from '@rneui/base';
import colors from '@theme/colors';
import { SVG_ICONS } from '@utils/SvgIcons';
import React from 'react';
import styles from './styles';

type RootStackParamList = {
  GGChatBot: undefined;
  [key: string]: any;
};

const ChatIcon: React.FC = () => {
  const navigation = useNavigation<RootStackParamList>();
  return (
    <FAB
      testID="btnChatBot"
      style={styles.fabStyles}
      loading={false}
      visible
      color={colors.primary.carnation}
      size="large"
      placement="right"
      onPress={() => {
        navigation.navigate(navigationConstants.GG_CHAT_BOT);
      }}>
      {SVG_ICONS.ChatLogo.chatLogo}
    </FAB>
  );
};

export default ChatIcon;
